import { contract } from 'lib/contract';

import * as page from './page';
import * as model from './model';
export { PagePrintMode } from './page';

contract({
  page,
  model
})